// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2iwz0","amount":"Amount_amount__3raTz","tip":"Amount_tip__1Ac4F","tipHeader":"Amount_tipHeader__2N6RZ","tipsWrap":"Amount_tipsWrap__1v_s1"};